// utils/ga4Utils.js - GA4 유틸리티 함수
import { generateDeviceId } from './deviceUtils';

/**
 * GA4에 user_id 설정
 * @param {string} userId - 사용자 ID (deviceId)
 */
export const setGA4UserId = (userId) => {
  try {
    const gtag = window.gtag;
    const measurementId = window.GA_MEASUREMENT_ID;
    if (typeof gtag === 'function' && measurementId && userId) {
      gtag('config', measurementId, {
        user_id: userId
      });
    }
  } catch (error) {
    console.warn('GA4 user_id 설정 실패:', error);
  }
};

/**
 * 현재 deviceId로 GA4 user_id 설정
 */
export const setGA4UserIdFromDevice = () => {
  try {
    const deviceId = generateDeviceId();
    setGA4UserId(deviceId);
  } catch (error) {
    console.warn('GA4 user_id 설정 실패:', error);
  }
};

/**
 * GA4 이벤트 전송 헬퍼 함수
 * @param {string} eventName - 이벤트 이름
 * @param {object} eventParams - 이벤트 파라미터
 */
export const sendGA4Event = (eventName, eventParams = {}) => {
  try {
    const gtag = window.gtag;
    const measurementId = window.GA_MEASUREMENT_ID;
    if (typeof gtag === 'function' && measurementId) {
      const deviceId = generateDeviceId();
      gtag('event', eventName, {
        ...eventParams,
        device_id: deviceId
      });
    }
  } catch (error) {
    console.warn('GA4 이벤트 전송 실패:', error);
  }
};

